export default __webpack_public_path__ + "static/media/Pistol_2.83911d3e.png";